import { render, staticRenderFns } from "./quality-assurance-ws.vue?vue&type=template&id=2a70036e&scoped=true&"
import script from "./quality-assurance-ws.vue?vue&type=script&lang=js&"
export * from "./quality-assurance-ws.vue?vue&type=script&lang=js&"
import style0 from "./quality-assurance-ws.vue?vue&type=style&index=0&id=2a70036e&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a70036e",
  null
  
)

export default component.exports